export default __webpack_public_path__ + "static/javascript-a4401a82840b0f23bac74b0e55c20637.webp";